// Form validation for Task form
import { plaintextValidator, nameValidator } from '../fields';

const config = { mandatory: true };

export default {
  firstName: nameValidator(config),
  lastName: nameValidator(config)
  // phoneNumber: plaintextValidator(config)
};
